import { render, staticRenderFns } from "./CommentSection.vue?vue&type=template&id=f6026534&scoped=true"
import script from "./CommentSection.vue?vue&type=script&lang=js"
export * from "./CommentSection.vue?vue&type=script&lang=js"
import style0 from "./CommentSection.vue?vue&type=style&index=0&id=f6026534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6026534",
  null
  
)

export default component.exports